import type { PropsWithChildren } from 'react';

import { CURRENT_SERVICE_TYPE, SERVICE_TYPE } from '@utility/checkout-utils';

import { AccountAccessDetailsProvider } from './AccountAccessDetailsProvider';
import { PaymentDetailsProvider } from './PaymentDetailsProvider';

export function ScaSubjectProvider({ children }: PropsWithChildren) {
  const useAccountAccess = CURRENT_SERVICE_TYPE === SERVICE_TYPE.AIS;
  const usePayments = !useAccountAccess;

  return (
    <AccountAccessDetailsProvider skip={!useAccountAccess}>
      <PaymentDetailsProvider skip={!usePayments}>
        {children}
      </PaymentDetailsProvider>
    </AccountAccessDetailsProvider>
  );
}

export const withScaSubjectProvider = ({ children }: PropsWithChildren) => (
  <ScaSubjectProvider>{children}</ScaSubjectProvider>
);
